export default __webpack_public_path__ + "5613e39616753a7e7730357189699562.png";